/**
 * Alpha Trial Agreement — v1 founder draft (spec §9). The server owns the
 * version string (currently "alpha-2026-05-29"); this is the display copy only.
 */
export const ALPHA_AGREEMENT_PARAGRAPHS: ReadonlyArray<{ title: string; body: string }> = [
  { title: 'This is alpha, pre-release software.', body: 'It will have rough edges and may change or break without notice.' },
  { title: "We don't guarantee accuracy.", body: 'The converter does its best to match your estimate to Xactimate codes, but you are responsible for reviewing every line before you rely on it. Don\'t submit an estimate you haven\'t checked.' },
  { title: 'Your files may contain personal information.', body: 'We process your uploaded PDF to produce your ESX and to improve the product. We keep it only while your project is active — an uploaded PDF is deleted after 30 days of inactivity on its project, and immediately if you delete the project.' },
  { title: "Feedback is gold, and we'll reward it.", body: 'Tell us what worked and what didn\'t. Genuinely useful feedback earns you a free credit for another conversion.' },
  { title: 'No warranty.', body: 'The software is provided "as is," without warranty of any kind. We\'re not liable for losses from using it. Access may be revoked at any time.' },
];

export function AlphaAgreementText({ className }: { className?: string }) {
  return (
    <div className={className}>
      <h2 className="mb-3 text-lg font-semibold text-primary">AI Estimate Assistant — Alpha Trial Agreement</h2>
      <p className="mb-3 text-sm text-gray-600">Thanks for trying the PDF→ESX converter. A few things to know before you start:</p>
      <ol className="list-decimal space-y-2 pl-5 text-sm text-gray-700">
        {ALPHA_AGREEMENT_PARAGRAPHS.map((p) => (
          <li key={p.title}><span className="font-medium">{p.title}</span> {p.body}</li>
        ))}
      </ol>
      <p className="mt-3 text-sm text-gray-600">By checking the box, you confirm you've read and agree to the above.</p>
    </div>
  );
}
